import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { PortalUser } from 'models';
import Heading, { Type } from 'components/UI/Heading';
import SortableTable, { HeaderCell } from 'components/UI/Table/SortableTable';
import EditModal from 'components/UI/EditModal';
import Button from 'components/UI/Button';

import { Content, ButtonGrid } from './styled';

// Azure header cells
const azureHeaderCells: HeaderCell[] = [
  {
    sortable: false,
    title: 'modal.roles_permission',
  },
];

type Props = {
  user: PortalUser | null;
  open: boolean;
  onClose: () => void;
};

const RolesModal: FC<Props> = ({ user, open, onClose }) => {
  // Azure roles
  const azureBodyRows = useMemo(() => {
    if (!user) {
      return [];
    }
    return user.roles.map((role) => ({
      permission: role.permission,
    }));
  }, [user]);

  return (
    <EditModal title="modal.roles_title" open={open} close={onClose}>
      <div>
        <Content>
          <FormattedMessage
            id="modal.roles_description"
            values={{
              name: user?.displayName,
              email: user?.email,
            }}
          />
        </Content>
        <Heading type={Type.h3}>Azure</Heading>
        <SortableTable
          headerCells={azureHeaderCells}
          bodyRows={azureBodyRows}
          emptyTextId="modal.roles_empty"
        />
        <ButtonGrid>
          <Button
            onClick={onClose}
            backgroundColor="transparent"
            color="primary"
          >
            <FormattedMessage id="modal.btn_close" />
          </Button>
        </ButtonGrid>
      </div>
    </EditModal>
  );
};

export default RolesModal;
